//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppSpinner',
  props: {
    size: {
      type: String,
      default: '70'
    },
    width: {
      type: String,
      default: '6'
    },
    colour: {
      type: String,
      default: 'primary'
    },
    text: {
      type: String,
      default: 'Loading...'
    }
  }
}
